import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivityModel } from '../../../../modules/user/activity/activity.model';
import { ActivityService } from '../../../../modules/user/activity/activity.service';

@Component({
    selector: 'app-autocomplete-select-activity',
    templateUrl: './autocomplete-select-activity.component.html',
    styleUrls: ['./autocomplete-select-activity.component.css'],
    standalone: false
})
export class AutocompleteSelectActivityComponent implements OnInit, OnChanges {
  @Input() selectedItemId: any = null;
  @Input() isRequired: boolean = false;

  inputControl = new UntypedFormControl();
  public items: ActivityModel[] = [];

  constructor(private service: ActivityService) {

  }

  ngOnInit() {
    this.service.getList()
      .then(response => {
        this.items = response;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
  }
  public trackByIndex(i: number) { return i; }

}
